module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.6@readable-stream/passthrough.js
// module id = a+xa
// module chunks = 0